module.exports = __webpack_public_path__ + "img/folder.7a6812ee.svg";